<template>
    <div class="card">
        <h6>Search Criteria:</h6>

        <Accordion>
            <AccordionTab header="Use as few or as many as you wish, partial matches are acceptable.">
                <!-- All the criterias here -->
                <div class="p-fluid formgrid grid">
                    <div class="field col-6 md:col-3">
                        <label for="incidentNo">Incident No:</label>
                        <InputText id="incidentNo" type="text" v-model="search.incidentNo" />
                    </div>
                    <div class="field col-6 md:col-3">
                        <base-selection-input v-model="search.learningIdentified" label="Learning Identified" :radio-type="true" :options="getCriteriaYesNoOptions()" />
                    </div>

                    <div class="field col-12 sm:col-6 md:col-3">
                        <UsersPicker label="Author" v-model="search.authorId" />
                    </div>

                    <div class="field col-12 sm:col-6 md:col-3"><custom-tree-select v-model="search.theme_id" label="Theme" :optionsTree="themeTree" /></div>

                    <div class="field col-12 sm:col-6 md:col-3">
                        <base-calendar-input v-model="search.created_at_from" :label="`${label('Debrief')} Created Date From`" dateFormat="dd-mm-yy" />
                    </div>
                    <div class="field col-12 sm:col-6 md:col-3">
                        <base-calendar-input v-model="search.created_at_to" :label="`${label('Debrief')} Created Date To`" dateFormat="dd-mm-yy" />
                    </div>

                    <div class="field col-6 md:col-3">
                        <base-calendar-input v-model="search.incident_date_from" label="Incident Date From" dateFormat="dd-mm-yy" />
                    </div>
                    <div class="field col-6 md:col-3">
                        <base-calendar-input v-model="search.incident_date_to" label="Incident Date To" dateFormat="dd-mm-yy" />
                    </div>

                    <div class="field col-12 sm:col-6 md:col-3">
                        <base-selection-input v-model="search.complete" :label="`${label('Debrief')} Status`" :radio-type="true" :options="getDebriefStatus()" />
                    </div>
                    <div class="field col-12 sm:col-6 md:col-3">
                        <base-dropdown v-model="search.taskStatus" :label="`${label('Debrief')} Progress`" :options="getAllProgress()" />
                    </div>

                    <div class="field col-12 sm:col-6 md:col-3">
                        <base-selection-input v-model="search.learning_outcome_complete" label="All Learnings Completed" :radio-type="true" :options="getYesNoOptions()" />
                    </div>

                    <div class="field col-6 md:col-3">
                        <base-multi-select v-model="search.appliance_id" label="Call Sign" :options="appliances" optionLabel="name" optionValue="id" displayType="comma" />
                    </div>

                    <div class="field col-6 md:col-3">
                        <base-multi-select
                            v-model="search.category"
                            label="Incident/Exercise"
                            :options="incidentCategory"
                            optionLabel="name"
                            optionValue="id"
                            displayType="comma"
                        />
                    </div>
                    <div class="field col-6 md:col-3">
                        <label for="debriefId">{{ label('Debrief') }} ID:</label>
                        <InputText id="debriefId" type="text" v-model="search.debriefId" />
                    </div>

                    <div class="field col-12 sm:col-6 md:col-3">
                        <label class="mb-2" for="exercise_name">Exercise Name</label>
                        <autocomplete id="exercise_name" dropdown v-model="search.exercise_name"
                            :suggestions="exerciseNameSuggestions" @complete="searchExerciseNameSuggestions" />
                    </div>

                    <div class="col-12"></div>

                    <div class="mt-3">
                        <div class="flex justify-content-end gap-2 col-12">
                            <Button type="button" label="Search" icon="pi pi-search" :loading="loading" class="mr-2" @click="loadDebriefs" />
                            <Button type="button" label="Clear" icon="pi pi-trash" @click="clearSearch" />
                        </div>
                    </div>
                </div>
            </AccordionTab>
        </Accordion>
    </div>
</template>

<script setup>
import UsersPicker from '@/modules/user/components/UsersPicker.vue';

import { onMounted, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useLabels } from '@/composables/LabelComposable';

const { label } = useLabels();

import { applianceStore, debriefStore, themeStore } from '@/store/global-stores';
import { getDebriefStatus } from '../constants';
import { getAllProgress } from '../../../constants';
import { getYesNoOptions, getCriteriaYesNoOptions } from '../../../../../constants';
import { showToast } from '../../../../../utilities/toast-handler';
import { getCategoriesForDebrief } from '@/product/ams/constants/index.js';
import { buildPagination } from '@/composables/PaginationComposable';


const { search, loading, exerciseNameSuggestions  } = storeToRefs(debriefStore);
const { themes, themeTree } = storeToRefs(themeStore);
const { appliances } = storeToRefs(applianceStore);

const searchExerciseNameSuggestions = debriefStore.searchExerciseNameSuggestions;


onMounted(() => {
    loadThemes();
    applianceStore.fetchAllAppliances();
});

onUnmounted(() => {
    //debriefStore.initSearch();
});

const incidentCategory = getCategoriesForDebrief();

const loadThemes = async () => {
    if (themes.value.length <= 0) {
        themeStore.fetchAllThemes();
    }
};

const loadDebriefs = async () => {
    buildPagination("debriefList", 0, 10, [{field: "created_at", order: -1}])
    debriefStore.fetchAllDebriefs('debriefList');
};

const clearSearch = async () => {
    debriefStore.initSearch();
    showToast({ severity: 'info', summary: 'Filters Cleared' }, 'All Criteria filters have been cleared');
    loadDebriefs();
};
</script>
